import * as React from 'react';
import { ScatterChart } from '@mui/x-charts/ScatterChart';
import { Stack, Box, Typography } from '@mui/material';

export default function GridDemo(props: any) {
  return (
    <Box sx={{
      '& .MuiChartsLegend-root' : {display:'none'}
    }}>
      <ScatterChart
        height={300}
        margin={{ left: 40, right: 20 }}
        series={props.series}
        grid={{ vertical: true, horizontal: true }}
        tooltip={{ trigger: 'none' }}
        // colors={['#800d8d', 'rgba(188,95,243,0.7)', '#2c6914', '#77c059', '#d9448d', '#ec70ac', '#eac222']}
        colors={props.colors}
      />

      
      
    </Box>
  );
}